module.exports = __webpack_public_path__ + "static/media/logo.4aa0e7c5.svg";